<template>
<div>
  <b-card>
    <div class="text-right mb-3">
      <router-link class="btn btn-primary" :to="{name:'ola.import'}"><i class="fa fa-files"></i> Importar</router-link>
      <router-link class="btn btn-primary" :to="{name:'ola.create'}"><i class="fa fa-plus"></i> Criar</router-link>
    </div>
    <grid-filters grid-data="theGrid" :fields="gridFilters" ></grid-filters>
    <Grid ref="theGrid" name="olaGrid" v-bind:url="url" v-bind:preload="preload" v-bind:columns="columns" :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
  </b-card>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'
import lists from '@/components/States.js'

export default {
  name: 'olaGrid',
  components: {
    Grid
  },
  data() {
    return {
      gridFilters: [{
        field:'dsr_id',
        modal:'dsr-modal',
        foreign: 'id',
        placeholder: 'DSR'
      }],
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'dsr_id': {
          type: 'number'
        }
      },
      preload: [{
        api: 'dsr/lst/dsr',
        field: 'dsr_id'
      }],
      url: 'ola',
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '120px'
      },
      {
        field: 'ym',
        title: 'Ano/Mês',
        width: '120px'
      },
      {
        field: 'dsr_id',
        title: 'DSR',
        width: '220px'
      },
      {
        field: 'points',
        title: 'Pontos',
        width: '120px'
      },
      {
        field: 'reason',
        title: 'Razão',
        width: '120px'
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  },
  methods: {
    getBtnTemplate: function(item) {
      var route = router.resolve({
        name: 'ola.edit',
        params: {
          id: item.id
        }
      })
      if (this.$auth.check('ola.edit')) {
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      }
      return ''
    }
  }
}
</script>
